<template>
    <div>
        <modal class="verfied-alarm-modal" :display="modalStatus.verifiedAlarm" @modalStatus="closeModal" >
            <!-- <div class="verfied-alarm-modal-wrap">
                <img src="@/assets/img/icon/modal_alarm.svg" alt="" srcset="">
                <h1>審核中</h1>
                <div class="description">實名認證審核中，請稍候再試</div>
            </div> -->
            <!-- <div class="verfied-alarm-modal-wrap">
                <img src="@/assets/img/icon/modal_alarm.svg" alt="" srcset="">
                <h1>尚未認證房東</h1>
                <div class="description">請先完成實名認證</div>
            </div> -->
            <div class="verfied-alarm-modal-wrap">
                <img src="@/assets/img/icon/modal_alarm.svg" alt="" srcset="">
                <h1>{{title}}</h1>
                <div class="description">{{description}}</div>
            </div>
            <!-- <div class="btn-group">
                <button class="default-button confirm">確認</button>
            </div> -->
            <div class="btn-group">
                <button @click="submit()" class="default-button confirm">{{button}}</button>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
        }
    },
    props: {
  
    },
    mounted() {
        // this.$analytics.logEvent('實名認證提醒', { screen_name: '實名認證提醒'})
    },
    methods: {
        submit: function () {
            if(this.userStatus == 1 || this.userStatus == 6){
                this.closeModal()
                this.$router.push({ name: 'MemberCenter'})
            }else{
                this.closeModal()
            }
        },
        closeModal: function () {
            this.$store.dispatch('setModalStatus', {state: false, type: 'verifiedAlarm'})
        },
    },
    computed: {
        title: function () {
            //未認證 1 
            //審核中4
            //審查未通過6
            if(this.userStatus == 1){
                return '尚未認證房東'
            }else if(this.userStatus == 4){
                return '審核中'
            }else if(this.userStatus == 6){
                return '審核失敗'
            }
        },
        description: function () {
            if(this.userStatus == 1){
                return '請先完成實名認證'
            }else if(this.userStatus == 4){
                return '實名認證審核中，請稍候再試'
            }else if(this.userStatus == 6){
                return '認證資料有誤，請重新進行認證'
            }
        },
        button: function () {
            if(this.userStatus == 1){
                return '至認證房東頁'
            }else if(this.userStatus == 4){
                return '確認'
            }else if(this.userStatus == 6){
                return '至認證房東頁'
            }
        },
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
            userStatus: 'GET_USER_STATUS',
        })
    },
    components: {
        Modal,
    }
}
</script>
<style lang="scss"  >
    #modal.verfied-alarm-modal{
        .error{
            right: 0px;
            top: 7px;
        }
        .modal-content{
            width: 448px;
            padding: 0 !important;
            .detail{
                >h1{
                    margin-top: 32px;
                    margin-bottom: 24px;
                }
                .verfied-alarm-modal-wrap{
                        padding: 40px 32px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                    h1{
                        font-size: 24px;
                        margin-top: 24px;
                        margin-bottom: 16px;
                    }
                    .description{
                        line-height: 1.57;
                        color: #676362;
                        margin-bottom: 10px;
                    }
                  
                }
            }
            
            .btn-group{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 84px;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                border-radius:  0 0 20px 20px;
                margin: 0 auto;
                button{
                    width: 384px;
                    height: 44px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/verifiedAlarmModal.vue